import * as i0 from '@angular/core';
import { Injectable, Component, ChangeDetectionStrategy, Renderer2, ChangeDetectorRef, ViewChild, ElementRef, ViewChildren, ContentChildren, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import * as objectPath from 'object-path';
import { StgSecuredObjectDirective, OauthSessionModule } from '@stg-js-ngx-core/oauth';
import { NgbTooltipModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { PerfectScrollbarModule, PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/router';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@stg-js-ngx-core/oauth';
import * as ɵngcc4 from '@ng-bootstrap/ng-bootstrap';

const _c0 = ["leftNav"];
const _c1 = ["asideMenu"];
const _c2 = function (a0) { return { item: a0 }; };
function AsideLeftComponent_ng_template_8_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 15);
} if (rf & 2) {
    const child_r13 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵnextContext(2);
    const _r4 = ɵngcc0.ɵɵreference(11);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r4)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c2, child_r13));
} }
function AsideLeftComponent_ng_template_8_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, AsideLeftComponent_ng_template_8_ng_container_0_ng_container_1_Template, 1, 4, "ng-container", 14);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const child_r13 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", child_r13.title);
} }
function AsideLeftComponent_ng_template_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, AsideLeftComponent_ng_template_8_ng_container_0_Template, 2, 1, "ng-container", 13);
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.menuList);
} }
const _c3 = function (a0, a1) { return { item: a0, parentItem: a1 }; };
function AsideLeftComponent_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 15);
} if (rf & 2) {
    const item_r16 = ctx.item;
    const parentItem_r17 = ctx.parentItem;
    ɵngcc0.ɵɵnextContext();
    const _r6 = ɵngcc0.ɵɵreference(13);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r6)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(2, _c3, item_r16, parentItem_r17));
} }
function AsideLeftComponent_ng_template_12_li_0_a_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 22);
    ɵngcc0.ɵɵelementContainer(1, 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = ɵngcc0.ɵɵnextContext(2);
    const item_r18 = ctx_r25.item;
    const parentItem_r19 = ctx_r25.parentItem;
    ɵngcc0.ɵɵnextContext();
    const _r10 = ɵngcc0.ɵɵreference(17);
    ɵngcc0.ɵɵproperty("href", item_r18.href, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r10)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(3, _c3, item_r18, parentItem_r19));
} }
function AsideLeftComponent_ng_template_12_li_0_a_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 23);
    ɵngcc0.ɵɵelementContainer(1, 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = ɵngcc0.ɵɵnextContext(2);
    const item_r18 = ctx_r26.item;
    const parentItem_r19 = ctx_r26.parentItem;
    ɵngcc0.ɵɵnextContext();
    const _r10 = ɵngcc0.ɵɵreference(17);
    ɵngcc0.ɵɵproperty("routerLink", item_r18.page);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r10)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(3, _c3, item_r18, parentItem_r19));
} }
function AsideLeftComponent_ng_template_12_li_0_a_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 24);
    ɵngcc0.ɵɵelementContainer(1, 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r27 = ɵngcc0.ɵɵnextContext(2);
    const item_r18 = ctx_r27.item;
    const parentItem_r19 = ctx_r27.parentItem;
    ɵngcc0.ɵɵnextContext();
    const _r10 = ɵngcc0.ɵɵreference(17);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r10)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(2, _c3, item_r18, parentItem_r19));
} }
function AsideLeftComponent_ng_template_12_li_0_div_4_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 28);
    ɵngcc0.ɵɵelementContainer(1, 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r30 = ɵngcc0.ɵɵnextContext(3);
    const item_r18 = ctx_r30.item;
    const parentItem_r19 = ctx_r30.parentItem;
    ɵngcc0.ɵɵnextContext();
    const _r8 = ɵngcc0.ɵɵreference(15);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r8)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(2, _c3, item_r18, parentItem_r19));
} }
function AsideLeftComponent_ng_template_12_li_0_div_4_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 15);
} if (rf & 2) {
    const ctx_r31 = ɵngcc0.ɵɵnextContext(3);
    const item_r18 = ctx_r31.item;
    const parentItem_r19 = ctx_r31.parentItem;
    ɵngcc0.ɵɵnextContext();
    const _r8 = ɵngcc0.ɵɵreference(15);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r8)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(2, _c3, item_r18, parentItem_r19));
} }
function AsideLeftComponent_ng_template_12_li_0_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 25);
    ɵngcc0.ɵɵelement(1, "span", 26);
    ɵngcc0.ɵɵtemplate(2, AsideLeftComponent_ng_template_12_li_0_div_4_div_2_Template, 2, 5, "div", 27);
    ɵngcc0.ɵɵtemplate(3, AsideLeftComponent_ng_template_12_li_0_div_4_ng_container_3_Template, 1, 5, "ng-container", 14);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r18 = ɵngcc0.ɵɵnextContext(2).item;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", item_r18["custom-class"] === "kt-menu__item--submenu-fullheight");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r18["custom-class"] !== "kt-menu__item--submenu-fullheight");
} }
function AsideLeftComponent_ng_template_12_li_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 17);
    ɵngcc0.ɵɵtemplate(1, AsideLeftComponent_ng_template_12_li_0_a_1_Template, 2, 6, "a", 18);
    ɵngcc0.ɵɵtemplate(2, AsideLeftComponent_ng_template_12_li_0_a_2_Template, 2, 6, "a", 19);
    ɵngcc0.ɵɵtemplate(3, AsideLeftComponent_ng_template_12_li_0_a_3_Template, 2, 5, "a", 20);
    ɵngcc0.ɵɵtemplate(4, AsideLeftComponent_ng_template_12_li_0_div_4_Template, 4, 2, "div", 21);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r18 = ɵngcc0.ɵɵnextContext().item;
    const ctx_r20 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r20.getItemCssClasses(item_r18))("ngbTooltip", !item_r18.submenu ? item_r18.title : "");
    ɵngcc0.ɵɵattribute("aria-haspopup", true)("data-ktmenu-submenu-toggle", ctx_r20.showSubMenuOn)("data-ktmenu-submenu-mode", item_r18.mode)("data-ktmenu-dropdown-toggle-class", item_r18["dropdown-toggle-class"]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !item_r18.submenu && item_r18.href);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !item_r18.submenu && !item_r18.href);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r18.submenu);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r18.submenu);
} }
function AsideLeftComponent_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, AsideLeftComponent_ng_template_12_li_0_Template, 5, 10, "li", 16);
} if (rf & 2) {
    const item_r18 = ctx.item;
    ɵngcc0.ɵɵproperty("stgSecuredObject", item_r18.stgSecuredObject);
} }
function AsideLeftComponent_ng_template_14_li_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 31);
    ɵngcc0.ɵɵelementStart(1, "a", 24);
    ɵngcc0.ɵɵelementStart(2, "span", 32);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r34 = ɵngcc0.ɵɵnextContext().item;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(item_r34.title);
} }
function AsideLeftComponent_ng_template_14_ng_container_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 15);
} if (rf & 2) {
    const child_r39 = ɵngcc0.ɵɵnextContext().$implicit;
    const item_r34 = ɵngcc0.ɵɵnextContext().item;
    ɵngcc0.ɵɵnextContext();
    const _r4 = ɵngcc0.ɵɵreference(11);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r4)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(2, _c3, child_r39, item_r34));
} }
function AsideLeftComponent_ng_template_14_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, AsideLeftComponent_ng_template_14_ng_container_2_ng_container_1_Template, 1, 5, "ng-container", 14);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const child_r39 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", child_r39.title);
} }
function AsideLeftComponent_ng_template_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 29);
    ɵngcc0.ɵɵtemplate(1, AsideLeftComponent_ng_template_14_li_1_Template, 4, 1, "li", 30);
    ɵngcc0.ɵɵtemplate(2, AsideLeftComponent_ng_template_14_ng_container_2_Template, 2, 1, "ng-container", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r34 = ctx.item;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r34.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", item_r34.submenu);
} }
function AsideLeftComponent_ng_template_16_i_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 40);
} if (rf & 2) {
    const item_r43 = ɵngcc0.ɵɵnextContext().item;
    ɵngcc0.ɵɵproperty("ngClass", item_r43.iconClass);
} }
function AsideLeftComponent_ng_template_16_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 41);
    ɵngcc0.ɵɵelement(1, "img", 42);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r43 = ɵngcc0.ɵɵnextContext().item;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("src", item_r43.iconSrc, ɵngcc0.ɵɵsanitizeUrl);
} }
function AsideLeftComponent_ng_template_16_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 41);
    ɵngcc0.ɵɵelementStart(1, "span", 43);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "slice");
    ɵngcc0.ɵɵpipe(4, "uppercase");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r43 = ɵngcc0.ɵɵnextContext().item;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind3(3, 1, ɵngcc0.ɵɵpipeBind1(4, 5, item_r43.iconText), 0, 2));
} }
function AsideLeftComponent_ng_template_16_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "i", 44);
    ɵngcc0.ɵɵelement(1, "span");
    ɵngcc0.ɵɵelementEnd();
} }
function AsideLeftComponent_ng_template_16_i_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "i", 45);
    ɵngcc0.ɵɵelement(1, "span");
    ɵngcc0.ɵɵelementEnd();
} }
function AsideLeftComponent_ng_template_16_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 46);
    ɵngcc0.ɵɵelementStart(1, "span", 47);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r43 = ɵngcc0.ɵɵnextContext().item;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", item_r43.badge.type);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(item_r43.badge.value);
} }
function AsideLeftComponent_ng_template_16_i_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 48);
} }
function AsideLeftComponent_ng_template_16_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, AsideLeftComponent_ng_template_16_i_0_Template, 1, 1, "i", 33);
    ɵngcc0.ɵɵtemplate(1, AsideLeftComponent_ng_template_16_span_1_Template, 2, 1, "span", 34);
    ɵngcc0.ɵɵtemplate(2, AsideLeftComponent_ng_template_16_span_2_Template, 5, 7, "span", 34);
    ɵngcc0.ɵɵtemplate(3, AsideLeftComponent_ng_template_16_i_3_Template, 2, 0, "i", 35);
    ɵngcc0.ɵɵtemplate(4, AsideLeftComponent_ng_template_16_i_4_Template, 2, 0, "i", 36);
    ɵngcc0.ɵɵelementStart(5, "span", 37);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, AsideLeftComponent_ng_template_16_span_7_Template, 3, 2, "span", 38);
    ɵngcc0.ɵɵtemplate(8, AsideLeftComponent_ng_template_16_i_8_Template, 1, 0, "i", 39);
} if (rf & 2) {
    const item_r43 = ctx.item;
    const parentItem_r44 = ctx.parentItem;
    ɵngcc0.ɵɵproperty("ngIf", item_r43.iconClass);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r43.iconSrc);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r43.iconText);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", parentItem_r44 && parentItem_r44.bullet === "dot");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", parentItem_r44 && parentItem_r44.bullet === "line");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("translate", item_r43.translate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(item_r43.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r43.badge);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r43.submenu);
} }
const _c4 = function () { return { "max-height": "calc(100vh - 60px)", "position": "relative" }; };
const _c5 = ["brand"];
function BrandComponent_img_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 8);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("src", ctx_r1.headerLogo, ɵngcc0.ɵɵsanitizeUrl);
} }
class LeftNavService {
    constructor() { }
}
LeftNavService.ɵfac = function LeftNavService_Factory(t) { return new (t || LeftNavService)(); };
LeftNavService.ɵprov = i0.ɵɵdefineInjectable({ factory: function LeftNavService_Factory() { return new LeftNavService(); }, token: LeftNavService, providedIn: "root" });
LeftNavService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LeftNavService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class LeftNavComponent {
    constructor() { }
    ngOnInit() {
    }
}
LeftNavComponent.ɵfac = function LeftNavComponent_Factory(t) { return new (t || LeftNavComponent)(); };
LeftNavComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: LeftNavComponent, selectors: [["lib-left-nav"]], decls: 2, vars: 0, template: function LeftNavComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p");
        ɵngcc0.ɵɵtext(1, " left-nav works! ");
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
LeftNavComponent.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LeftNavComponent, [{
        type: Component,
        args: [{
                selector: 'lib-left-nav',
                template: `
    <p>
      left-nav works!
    </p>
  `
            }]
    }], function () { return []; }, null); })();

class AsideLeftComponent {
    /**
     * Component Conctructor
     *
     * @param router: Router
     * @param render: Renderer2
     * @param cdr: ChangeDetectorRef
     */
    constructor(router, render, cdr) {
        this.router = router;
        this.render = render;
        this.cdr = cdr;
        this.showSubMenuOn = 'click';
        this.currentRouteUrl = '';
        this.menuCanvasOptions = {
            baseClass: 'kt-aside',
            overlay: true,
            closeBy: 'kt_aside_close_btn',
            toggleBy: {
                target: 'kt_aside_mobile_toggler',
                state: 'kt-header-mobile__toolbar-toggler--active'
            }
        };
        this.scrollBarOptions = {
            suppressScrollX: true
        };
        this.menuOptions = {
            // vertical scroll
            scroll: null,
            // submenu setup
            submenu: {
                desktop: {
                    // by default the menu mode set to accordion in desktop mode
                    default: 'dropdown',
                    // whenever body has this class switch the menu mode to dropdown
                    state: {
                        body: 'kt-aside--minimize',
                        mode: 'dropdown'
                    }
                },
                tablet: 'accordion',
                mobile: 'accordion' // menu set to accordion in mobile mode
            },
            // accordion setup
            accordion: {
                expandAll: false // allow having multiple expanded accordions in the menu
            }
        };
    }
    ngAfterViewInit() {
        this.render.setAttribute(this.asideMenu.nativeElement, 'data-ktmenu-dropdown', '1');
        // tslint:disable-next-line:max-line-length
        this.render.setAttribute(this.asideMenu.nativeElement, 'data-ktmenu-dropdown-timeout', '500');
        this.setupOptions();
        let menu = new KTMenu(this.asideMenu.nativeElement, this.menuOptions);
        let offcanvas = new KTOffcanvas(this.leftNav.nativeElement, this.menuCanvasOptions);
        this.allSecuredObjDirectiveList.toArray().forEach(securedObjectDirective => {
            securedObjectDirective.subscribeToRoleChange();
        });
    }
    ngAfterContentInit() {
        this.allSecuredObjDirectiveListFromTransclusion.toArray().forEach(securedObjectDirective => {
            securedObjectDirective.subscribeToRoleChange();
        });
    }
    ngOnInit() {
        this.initAside();
        this.currentRouteUrl = this.router.url.split(/[?#]/)[0];
        this.router.events
            .subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.currentRouteUrl = this.router.url.split(/[?#]/)[0];
                this.cdr.markForCheck();
            }
        });
    }
    initAside() {
        // if (objectPath.get(this.config, 'aside.self.display') !== true) {
        //   return;
        // }
        document.body.classList.add('kt-aside--enabled');
        // Fixed Aside
        if (this.staticAside) {
            document.body.classList.add('kt-aside--static');
        }
        else {
            document.body.classList.add('kt-aside--fixed');
            // objectPath.push(this.classes, 'aside', 'kt-aside--fixed');
        }
        // Default fixed
        if (this.minimizeOnLoad) {
            document.body.classList.add('kt-aside--minimize');
        }
    }
    setupOptions() {
        // init aside menu
        let menuDesktopMode = 'accordion';
        if (this.asideMenu.nativeElement.getAttribute('data-ktmenu-dropdown') === '1') {
            menuDesktopMode = 'dropdown';
        }
        if (typeof objectPath.get(this.menuOptions, 'submenu.desktop') === 'object') {
            objectPath.set(this.menuOptions, 'submenu.desktop', menuDesktopMode);
        }
    }
    /**
     * Check Menu is active
     * @param item: any
     */
    isMenuItemIsActive(item) {
        if (item.submenu) {
            return this.isMenuRootItemIsActive(item);
        }
        if (!item.page) {
            return false;
        }
        return this.currentRouteUrl.indexOf(item.page) !== -1;
    }
    /**
     * Check Menu Root Item is active
     * @param item: any
     */
    isMenuRootItemIsActive(item) {
        let result = false;
        for (const subItem of item.submenu) {
            result = this.isMenuItemIsActive(subItem);
            if (result) {
                return true;
            }
        }
        return false;
    }
    /**
     * Use for fixed left aside menu, to show menu on mouseenter event.
     * @param e Event
     */
    mouseEnter(e) {
        // check if the left aside menu is fixed
        if (this.staticAside) {
            if (this.outsideTm) {
                clearTimeout(this.outsideTm);
                this.outsideTm = null;
            }
            this.insideTm = setTimeout(() => {
                // if the left aside menu is minimized
                if (document.body.classList.contains('kt-aside--minimize') && KTUtil.isInResponsiveRange('desktop')) {
                    // show the left aside menu
                    this.render.removeClass(document.body, 'kt-aside--minimize');
                    this.render.addClass(document.body, 'kt-aside--minimize-hover');
                }
            }, 50);
        }
    }
    /**
     * Use for fixed left aside menu, to show menu on mouseenter event.
     * @param e Event
     */
    mouseLeave(e) {
        if (this.staticAside) {
            if (this.insideTm) {
                clearTimeout(this.insideTm);
                this.insideTm = null;
            }
            this.outsideTm = setTimeout(() => {
                // if the left aside menu is expand
                if (document.body.classList.contains('kt-aside--minimize-hover') && KTUtil.isInResponsiveRange('desktop')) {
                    // hide back the left aside menu
                    this.render.removeClass(document.body, 'kt-aside--minimize-hover');
                    this.render.addClass(document.body, 'kt-aside--minimize');
                }
            }, 100);
        }
    }
    /**
     * Returns Submenu CSS Class Name
     * @param item: any
     */
    getItemCssClasses(item) {
        let classes = 'kt-menu__item';
        if (objectPath.get(item, 'submenu')) {
            classes += ' kt-menu__item--submenu';
        }
        if (!item.submenu && this.isMenuItemIsActive(item)) {
            classes += ' kt-menu__item--active kt-menu__item--here';
        }
        if (item.submenu && this.isMenuItemIsActive(item)) {
            classes += ' kt-menu__item--active kt-menu__item--open kt-menu__item--here';
        }
        // custom class for menu item
        const customClass = objectPath.get(item, 'custom-class');
        if (customClass) {
            classes += ' ' + customClass;
        }
        if (objectPath.get(item, 'icon-only')) {
            classes += ' kt-menu__item--icon-only';
        }
        return classes;
    }
}
AsideLeftComponent.ɵfac = function AsideLeftComponent_Factory(t) { return new (t || AsideLeftComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.Router), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
AsideLeftComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AsideLeftComponent, selectors: [["stg-ngx-left-nav"]], contentQueries: function AsideLeftComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, StgSecuredObjectDirective, 4, StgSecuredObjectDirective);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.allSecuredObjDirectiveListFromTransclusion = _t);
    } }, viewQuery: function AsideLeftComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 5, ElementRef);
        ɵngcc0.ɵɵviewQuery(_c1, 5, ElementRef);
        ɵngcc0.ɵɵviewQuery(StgSecuredObjectDirective, 5, StgSecuredObjectDirective);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.leftNav = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.asideMenu = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.allSecuredObjDirectiveList = _t);
    } }, inputs: { showSubMenuOn: "showSubMenuOn", menuList: "menuList", headerLogo: "headerLogo", staticAside: "staticAside", minimizeOnLoad: "minimizeOnLoad" }, decls: 18, vars: 4, consts: [["id", "kt_aside", 1, "kt-aside", "kt-aside--fixed", "kt-grid__item", "kt-grid", "kt-grid--desktop", "kt-grid--hor-desktop"], ["leftNav", ""], [3, "headerLogo"], ["id", "kt_aside_menu_wrapper", 1, "kt-aside-menu-wrapper", "kt-grid__item", "kt-grid__item--fluid"], ["id", "kt_aside_menu", 1, "kt-aside-menu", "kt-aside-menu--dropdown", 3, "ngStyle", "mouseenter", "mouseleave"], ["asideMenu", ""], [1, "kt-menu__nav"], [3, "ngTemplateOutlet"], ["menuListTemplate", ""], ["menuItemTemplate", ""], ["menuItemInnerTemplate", ""], ["menuSubmenuTemplate", ""], ["menuItemTextTemplate", ""], [4, "ngFor", "ngForOf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["placement", "right", 3, "ngClass", "ngbTooltip", 4, "stgSecuredObject"], ["placement", "right", 3, "ngClass", "ngbTooltip"], ["target", "_blank", "class", "kt-menu__link", 3, "href", 4, "ngIf"], ["class", "kt-menu__link kt-menu__toggle", 3, "routerLink", 4, "ngIf"], ["class", "kt-menu__link kt-menu__toggle", 4, "ngIf"], ["class", "kt-menu__submenu", 4, "ngIf"], ["target", "_blank", 1, "kt-menu__link", 3, "href"], [1, "kt-menu__link", "kt-menu__toggle", 3, "routerLink"], [1, "kt-menu__link", "kt-menu__toggle"], [1, "kt-menu__submenu"], [1, "kt-menu__arrow"], ["class", "kt-menu__wrapper", 4, "ngIf"], [1, "kt-menu__wrapper"], [1, "kt-menu__subnav"], ["class", "kt-menu__item submenu-heading", 4, "ngIf"], [1, "kt-menu__item", "submenu-heading"], [1, "kt-menu__link-text"], ["class", "kt-menu__link-icon", 3, "ngClass", 4, "ngIf"], ["class", "kt-menu__link-icon", 4, "ngIf"], ["class", "kt-menu__link-bullet kt-menu__link-bullet--dot", 4, "ngIf"], ["class", "kt-menu__link-bullet kt-menu__link-bullet--line", 4, "ngIf"], [1, "kt-menu__link-text", 3, "translate"], ["class", "kt-menu__link-badge", 4, "ngIf"], ["class", "kt-menu__ver-arrow fas fa-angle-right", 4, "ngIf"], [1, "kt-menu__link-icon", 3, "ngClass"], [1, "kt-menu__link-icon"], ["alt", "", 1, "menu-img-icon", 3, "src"], [1, "menu-img-text-circle"], [1, "kt-menu__link-bullet", "kt-menu__link-bullet--dot"], [1, "kt-menu__link-bullet", "kt-menu__link-bullet--line"], [1, "kt-menu__link-badge"], [1, "kt-badge", 3, "ngClass"], [1, "kt-menu__ver-arrow", "fas", "fa-angle-right"]], template: function AsideLeftComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵelement(2, "kt-brand", 2);
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4, 5);
        ɵngcc0.ɵɵlistener("mouseenter", function AsideLeftComponent_Template_div_mouseenter_4_listener($event) { return ctx.mouseEnter($event); })("mouseleave", function AsideLeftComponent_Template_div_mouseleave_4_listener($event) { return ctx.mouseLeave($event); });
        ɵngcc0.ɵɵelementStart(6, "ul", 6);
        ɵngcc0.ɵɵelementContainer(7, 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, AsideLeftComponent_ng_template_8_Template, 1, 1, "ng-template", null, 8, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(10, AsideLeftComponent_ng_template_10_Template, 1, 5, "ng-template", null, 9, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(12, AsideLeftComponent_ng_template_12_Template, 1, 1, "ng-template", null, 10, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(14, AsideLeftComponent_ng_template_14_Template, 3, 2, "ng-template", null, 11, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(16, AsideLeftComponent_ng_template_16_Template, 9, 9, "ng-template", null, 12, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r2 = ɵngcc0.ɵɵreference(9);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("headerLogo", ctx.headerLogo);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction0(3, _c4));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r2);
    } }, directives: function () { return [BrandComponent, ɵngcc2.NgStyle, ɵngcc2.NgTemplateOutlet, ɵngcc2.NgForOf, ɵngcc2.NgIf, ɵngcc3.StgSecuredObjectDirective, ɵngcc2.NgClass, ɵngcc4.NgbTooltip, ɵngcc1.RouterLinkWithHref]; }, pipes: function () { return [ɵngcc2.SlicePipe, ɵngcc2.UpperCasePipe]; }, styles: ["[_nghost-%COMP%]   .kt-aside[_ngcontent-%COMP%]{height:100%}.kt-menu__link-text[_ngcontent-%COMP%]{word-break:break-word}.kt-menu__submenu[_ngcontent-%COMP%]   .menu-img-text-circle[_ngcontent-%COMP%]{height:20px;width:20px;font-size:12px;padding-top:10px}.menu-img-text-circle[_ngcontent-%COMP%]{height:30px;width:30px;background:#4c4c4c;border-radius:50%;padding-top:16px;font-size:17px;text-align:center}.menu-img-icon[_ngcontent-%COMP%]{max-height:30px;max-width:30px}@media (max-width: 1024px){.menu-img-text-circle[_ngcontent-%COMP%]{height:20px;width:20px;padding-top:10px;font-size:12px;padding-left:1px}.menu-img-icon[_ngcontent-%COMP%]{max-width:20px;max-height:20px}}.kt-aside-menu[_ngcontent-%COMP%]   .kt-menu__nav[_ngcontent-%COMP%] > .kt-menu__item[_ngcontent-%COMP%] > .kt-menu__link[_ngcontent-%COMP%] > .kt-menu__link-icon[_ngcontent-%COMP%], .kt-aside-menu[_ngcontent-%COMP%]   .kt-menu__nav[_ngcontent-%COMP%] > .kt-menu__item[_ngcontent-%COMP%] > .kt-menu__link[_ngcontent-%COMP%] > .kt-menu__link-text[_ngcontent-%COMP%], .kt-aside-menu[_ngcontent-%COMP%]   .kt-menu__nav[_ngcontent-%COMP%] > .kt-menu__item[_ngcontent-%COMP%] > .kt-menu__link[_ngcontent-%COMP%] > .kt-menu__ver-arrow[_ngcontent-%COMP%], .kt-aside-menu[_ngcontent-%COMP%]   .kt-menu__nav[_ngcontent-%COMP%] > .kt-menu__item[_ngcontent-%COMP%]   .kt-menu__submenu[_ngcontent-%COMP%]   .kt-menu__item[_ngcontent-%COMP%] > .kt-menu__link[_ngcontent-%COMP%]   .kt-menu__link-icon[_ngcontent-%COMP%], .kt-aside-menu[_ngcontent-%COMP%]   .kt-menu__nav[_ngcontent-%COMP%] > .kt-menu__item[_ngcontent-%COMP%]   .kt-menu__submenu[_ngcontent-%COMP%]   .kt-menu__item[_ngcontent-%COMP%] > .kt-menu__link[_ngcontent-%COMP%]   .kt-menu__link-text[_ngcontent-%COMP%], .kt-aside-menu[_ngcontent-%COMP%]   .kt-menu__nav[_ngcontent-%COMP%] > .kt-menu__item[_ngcontent-%COMP%]   .kt-menu__submenu[_ngcontent-%COMP%]   .kt-menu__item[_ngcontent-%COMP%] > .kt-menu__link[_ngcontent-%COMP%]   .kt-menu__ver-arrow[_ngcontent-%COMP%]{color:#d0d0d0!important}.kt-aside-menu[_ngcontent-%COMP%]   .kt-menu__nav[_ngcontent-%COMP%] > .kt-menu__item.kt-menu__item--active[_ngcontent-%COMP%] > .kt-menu__link[_ngcontent-%COMP%] > .kt-menu__link-icon[_ngcontent-%COMP%], .kt-aside-menu[_ngcontent-%COMP%]   .kt-menu__nav[_ngcontent-%COMP%] > .kt-menu__item.kt-menu__item--active[_ngcontent-%COMP%] > .kt-menu__link[_ngcontent-%COMP%] > .kt-menu__link-text[_ngcontent-%COMP%], .kt-aside-menu[_ngcontent-%COMP%]   .kt-menu__nav[_ngcontent-%COMP%] > .kt-menu__item.kt-menu__item--active[_ngcontent-%COMP%] > .kt-menu__link[_ngcontent-%COMP%] > .kt-menu__ver-arrow[_ngcontent-%COMP%], .kt-aside-menu[_ngcontent-%COMP%]   .kt-menu__nav[_ngcontent-%COMP%] > .kt-menu__item[_ngcontent-%COMP%]   .kt-menu__submenu[_ngcontent-%COMP%]   .kt-menu__item.kt-menu__item--active[_ngcontent-%COMP%] > .kt-menu__link[_ngcontent-%COMP%]   .kt-menu__link-icon[_ngcontent-%COMP%], .kt-aside-menu[_ngcontent-%COMP%]   .kt-menu__nav[_ngcontent-%COMP%] > .kt-menu__item[_ngcontent-%COMP%]   .kt-menu__submenu[_ngcontent-%COMP%]   .kt-menu__item.kt-menu__item--active[_ngcontent-%COMP%] > .kt-menu__link[_ngcontent-%COMP%]   .kt-menu__link-text[_ngcontent-%COMP%], .kt-aside-menu[_ngcontent-%COMP%]   .kt-menu__nav[_ngcontent-%COMP%] > .kt-menu__item[_ngcontent-%COMP%]   .kt-menu__submenu[_ngcontent-%COMP%]   .kt-menu__item.kt-menu__item--active[_ngcontent-%COMP%] > .kt-menu__link[_ngcontent-%COMP%]   .kt-menu__ver-arrow[_ngcontent-%COMP%]{color:#3598dc!important}.kt-menu__subnav[_ngcontent-%COMP%]{background-color:#1e1e2d!important;color:#d0d0d0!important;padding:15px 0!important}.kt-aside-menu[_ngcontent-%COMP%]   .kt-menu__nav[_ngcontent-%COMP%] > .kt-menu__item[_ngcontent-%COMP%]   .kt-menu__submenu[_ngcontent-%COMP%]   .kt-menu__item[_ngcontent-%COMP%]:not(.kt-menu__item--parent):not(.kt-menu__item--open):not(.kt-menu__item--here):not(.kt-menu__item--active):hover > .kt-menu__link[_ngcontent-%COMP%], .kt-aside-menu[_ngcontent-%COMP%]   .kt-menu__nav[_ngcontent-%COMP%] > .kt-menu__item[_ngcontent-%COMP%]   .kt-menu__submenu[_ngcontent-%COMP%]   .kt-menu__item.kt-menu__item--active[_ngcontent-%COMP%] > .kt-menu__link[_ngcontent-%COMP%], .kt-aside-menu.kt-aside-menu--dropdown[_ngcontent-%COMP%]   .kt-menu__nav[_ngcontent-%COMP%]   .kt-menu__item[_ngcontent-%COMP%]:not([data-ktmenu-submenu-mode=accordion]).kt-menu__item--hover > .kt-menu__submenu[_ngcontent-%COMP%]   .kt-menu__subnav[_ngcontent-%COMP%]   .kt-menu__item.kt-menu__item--here[_ngcontent-%COMP%] > .kt-menu__link[_ngcontent-%COMP%]{background-color:#1b1b28!important}.kt-menu__ver-arrow[_ngcontent-%COMP%]{font-size:13px!important}.submenu-heading[_ngcontent-%COMP%]{display:none!important}  .kt-aside--minimize .submenu-heading{display:block!important;border-bottom:1px solid #6ca3fb80}  .kt-aside--minimize .submenu-heading .kt-menu__link{padding-top:0!important;padding-bottom:15px!important;min-height:30px!important}  .kt-aside--minimize .submenu-heading .kt-menu__link .kt-menu__Link-text{font-size:15px}@media (max-width: 1024px){.submenu-heading[_ngcontent-%COMP%]{display:none!important}}"], changeDetection: 0 });
AsideLeftComponent.ctorParameters = () => [
    { type: Router },
    { type: Renderer2 },
    { type: ChangeDetectorRef }
];
AsideLeftComponent.propDecorators = {
    leftNav: [{ type: ViewChild, args: ['leftNav', { read: ElementRef },] }],
    asideMenu: [{ type: ViewChild, args: ['asideMenu', { read: ElementRef },] }],
    allSecuredObjDirectiveList: [{ type: ViewChildren, args: [StgSecuredObjectDirective, { read: StgSecuredObjectDirective },] }],
    allSecuredObjDirectiveListFromTransclusion: [{ type: ContentChildren, args: [StgSecuredObjectDirective, { read: StgSecuredObjectDirective },] }],
    menuList: [{ type: Input }],
    headerLogo: [{ type: Input }],
    staticAside: [{ type: Input }],
    minimizeOnLoad: [{ type: Input }],
    showSubMenuOn: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AsideLeftComponent, [{
        type: Component,
        args: [{
                selector: 'stg-ngx-left-nav',
                template: "<!-- BEGIN: Left Aside -->\r\n<div class=\"kt-aside kt-aside--fixed kt-grid__item kt-grid kt-grid--desktop kt-grid--hor-desktop\" id=\"kt_aside\" #leftNav>\r\n  <!-- begin:: Brand -->\r\n  <kt-brand [headerLogo]=\"headerLogo\"></kt-brand>\r\n  <!-- end:: Brand -->\r\n\r\n  <!-- BEGIN: Aside Menu -->\r\n  <div class=\"kt-aside-menu-wrapper kt-grid__item kt-grid__item--fluid\" id=\"kt_aside_menu_wrapper\">\r\n    <div #asideMenu id=\"kt_aside_menu\" [ngStyle]=\"{'max-height': 'calc(100vh - 60px)', 'position': 'relative'}\"\r\n         class=\"kt-aside-menu kt-aside-menu--dropdown\"\r\n         (mouseenter)=\"mouseEnter($event)\" (mouseleave)=\"mouseLeave($event)\">\r\n      <ul class=\"kt-menu__nav\">\r\n        <ng-container [ngTemplateOutlet]=\"menuListTemplate\"></ng-container>\r\n      </ul>\r\n    </div>\r\n  </div>\r\n  <!-- END: Aside Menu -->\r\n</div>\r\n<!-- END: Left Aside -->\r\n\r\n<ng-template #menuListTemplate>\r\n  <ng-container *ngFor=\"let child of menuList\">\r\n    <ng-container *ngIf=\"child.title\" [ngTemplateOutlet]=\"menuItemTemplate\"\r\n                  [ngTemplateOutletContext]=\"{ item: child }\"></ng-container>\r\n  </ng-container>\r\n</ng-template>\r\n\r\n<ng-template #menuItemTemplate let-item=\"item\" let-parentItem=\"parentItem\">\r\n  <ng-container [ngTemplateOutlet]=\"menuItemInnerTemplate\" [ngTemplateOutletContext]=\"{ item: item, parentItem: parentItem  }\"></ng-container>\r\n</ng-template>\r\n\r\n<ng-template #menuItemInnerTemplate let-item=\"item\" let-parentItem=\"parentItem\">\r\n  <li [attr.aria-haspopup]=\"true\"\r\n      [attr.data-ktmenu-submenu-toggle]=\"showSubMenuOn\"\r\n      [attr.data-ktmenu-submenu-mode]=\"item.mode\"\r\n      [attr.data-ktmenu-dropdown-toggle-class]=\"item['dropdown-toggle-class']\" [ngClass]=\"getItemCssClasses(item)\"\r\n      [ngbTooltip]=\"!item.submenu ? item.title: ''\" placement=\"right\" *stgSecuredObject=\"item.stgSecuredObject\">\r\n\r\n    <!-- if menu item hasn't submenu and has href -->\r\n    <a *ngIf=\"!item.submenu && item.href\" [href]=\"item.href\" target=\"_blank\" class=\"kt-menu__link\">\r\n      <ng-container [ngTemplateOutlet]=\"menuItemTextTemplate\"\r\n                    [ngTemplateOutletContext]=\"{ item: item, parentItem: parentItem }\"></ng-container>\r\n    </a>\r\n\r\n    <!-- if menu item hasn't submenu -->\r\n    <a *ngIf=\"!item.submenu && !item.href\" [routerLink]=\"item.page\" class=\"kt-menu__link kt-menu__toggle\">\r\n      <ng-container [ngTemplateOutlet]=\"menuItemTextTemplate\"\r\n                    [ngTemplateOutletContext]=\"{ item: item, parentItem: parentItem }\"></ng-container>\r\n    </a>\r\n    <!-- if menu item has sumnenu child  -->\r\n    <a *ngIf=\"item.submenu\" class=\"kt-menu__link kt-menu__toggle\">\r\n      <ng-container [ngTemplateOutlet]=\"menuItemTextTemplate\"\r\n                    [ngTemplateOutletContext]=\"{ item: item, parentItem: parentItem }\"></ng-container>\r\n    </a>\r\n\r\n    <!-- if menu item has submenu child then recursively call new menu item component -->\r\n    <div *ngIf=\"item.submenu\" class=\"kt-menu__submenu\">\r\n      <span class=\"kt-menu__arrow\"></span>\r\n      <div *ngIf=\"item['custom-class'] === 'kt-menu__item--submenu-fullheight'\" class=\"kt-menu__wrapper\">\r\n        <!-- wrap submenu to full height -->\r\n        <ng-container [ngTemplateOutlet]=\"menuSubmenuTemplate\" [ngTemplateOutletContext]=\"{ item: item, parentItem: parentItem }\"></ng-container>\r\n      </div>\r\n      <!-- normal submenu -->\r\n      <ng-container *ngIf=\"item['custom-class'] !== 'kt-menu__item--submenu-fullheight'\"\r\n                    [ngTemplateOutlet]=\"menuSubmenuTemplate\"\r\n                    [ngTemplateOutletContext]=\"{ item: item, parentItem: parentItem }\">\r\n      </ng-container>\r\n    </div>\r\n  </li>\r\n</ng-template>\r\n\r\n<ng-template #menuSubmenuTemplate let-item=\"item\" let-parentItem=\"parentItem\">\r\n  <ul class=\"kt-menu__subnav\">\r\n    <li class=\"kt-menu__item submenu-heading\" *ngIf=\"item.title\">\r\n      <a class=\"kt-menu__link kt-menu__toggle\"><span class=\"kt-menu__link-text\">{{ item.title }}</span></a>\r\n    </li>\r\n    <ng-container *ngFor=\"let child of item.submenu\">\r\n      <ng-container *ngIf=\"child.title\" [ngTemplateOutlet]=\"menuItemTemplate\"\r\n                    [ngTemplateOutletContext]=\"{ item: child, parentItem: item }\"></ng-container>\r\n    </ng-container>\r\n  </ul>\r\n</ng-template>\r\n\r\n<ng-template #menuItemTextTemplate let-item=\"item\" let-parentItem=\"parentItem\">\r\n  <!-- if menu item has icon -->\r\n  <i *ngIf=\"item.iconClass\" class=\"kt-menu__link-icon\" [ngClass]=\"item.iconClass\"></i>\r\n\r\n  <!-- if menu item has icon image src-->\r\n  <span *ngIf=\"item.iconSrc\" class=\"kt-menu__link-icon\">\r\n    <img class=\"menu-img-icon\" [src]=\"item.iconSrc\" alt=\"\" />\r\n  </span>\r\n  <!-- if menu item has icon text-->\r\n  <span *ngIf=\"item.iconText\" class=\"kt-menu__link-icon\">\r\n    <span class=\"menu-img-text-circle\">{{item.iconText | uppercase | slice:0:2 }}</span>\r\n  </span>\r\n\r\n  <!-- if menu item using bullet -->\r\n  <i *ngIf=\"parentItem && parentItem.bullet === 'dot'\" class=\"kt-menu__link-bullet kt-menu__link-bullet--dot\">\r\n    <span></span>\r\n  </i>\r\n  <i *ngIf=\"parentItem && parentItem.bullet === 'line'\" class=\"kt-menu__link-bullet kt-menu__link-bullet--line\">\r\n    <span></span>\r\n  </i>\r\n\r\n  <!-- menu item title text -->\r\n  <span class=\"kt-menu__link-text\" [translate]=\"item.translate\">{{item.title}}</span>\r\n  <!-- menu item with badge -->\r\n  <span *ngIf=\"item.badge\" class=\"kt-menu__link-badge\">\r\n\t\t<span class=\"kt-badge\" [ngClass]=\"item.badge.type\">{{item.badge.value}}</span>\r\n\t</span>\r\n\r\n  <!-- if menu item has submenu child then put arrow icon -->\r\n  <i *ngIf=\"item.submenu\" class=\"kt-menu__ver-arrow fas fa-angle-right\"></i>\r\n</ng-template>\r\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [":host .kt-aside{height:100%}.kt-menu__link-text{word-break:break-word}.kt-menu__submenu .menu-img-text-circle{height:20px;width:20px;font-size:12px;padding-top:10px}.menu-img-text-circle{height:30px;width:30px;background:#4c4c4c;border-radius:50%;padding-top:16px;font-size:17px;text-align:center}.menu-img-icon{max-height:30px;max-width:30px}@media (max-width: 1024px){.menu-img-text-circle{height:20px;width:20px;padding-top:10px;font-size:12px;padding-left:1px}.menu-img-icon{max-width:20px;max-height:20px}}.kt-aside-menu .kt-menu__nav>.kt-menu__item>.kt-menu__link>.kt-menu__link-icon,.kt-aside-menu .kt-menu__nav>.kt-menu__item>.kt-menu__link>.kt-menu__link-text,.kt-aside-menu .kt-menu__nav>.kt-menu__item>.kt-menu__link>.kt-menu__ver-arrow,.kt-aside-menu .kt-menu__nav>.kt-menu__item .kt-menu__submenu .kt-menu__item>.kt-menu__link .kt-menu__link-icon,.kt-aside-menu .kt-menu__nav>.kt-menu__item .kt-menu__submenu .kt-menu__item>.kt-menu__link .kt-menu__link-text,.kt-aside-menu .kt-menu__nav>.kt-menu__item .kt-menu__submenu .kt-menu__item>.kt-menu__link .kt-menu__ver-arrow{color:#d0d0d0!important}.kt-aside-menu .kt-menu__nav>.kt-menu__item.kt-menu__item--active>.kt-menu__link>.kt-menu__link-icon,.kt-aside-menu .kt-menu__nav>.kt-menu__item.kt-menu__item--active>.kt-menu__link>.kt-menu__link-text,.kt-aside-menu .kt-menu__nav>.kt-menu__item.kt-menu__item--active>.kt-menu__link>.kt-menu__ver-arrow,.kt-aside-menu .kt-menu__nav>.kt-menu__item .kt-menu__submenu .kt-menu__item.kt-menu__item--active>.kt-menu__link .kt-menu__link-icon,.kt-aside-menu .kt-menu__nav>.kt-menu__item .kt-menu__submenu .kt-menu__item.kt-menu__item--active>.kt-menu__link .kt-menu__link-text,.kt-aside-menu .kt-menu__nav>.kt-menu__item .kt-menu__submenu .kt-menu__item.kt-menu__item--active>.kt-menu__link .kt-menu__ver-arrow{color:#3598dc!important}.kt-menu__subnav{background-color:#1e1e2d!important;color:#d0d0d0!important;padding:15px 0!important}.kt-aside-menu .kt-menu__nav>.kt-menu__item .kt-menu__submenu .kt-menu__item:not(.kt-menu__item--parent):not(.kt-menu__item--open):not(.kt-menu__item--here):not(.kt-menu__item--active):hover>.kt-menu__link,.kt-aside-menu .kt-menu__nav>.kt-menu__item .kt-menu__submenu .kt-menu__item.kt-menu__item--active>.kt-menu__link,.kt-aside-menu.kt-aside-menu--dropdown .kt-menu__nav .kt-menu__item:not([data-ktmenu-submenu-mode=accordion]).kt-menu__item--hover>.kt-menu__submenu .kt-menu__subnav .kt-menu__item.kt-menu__item--here>.kt-menu__link{background-color:#1b1b28!important}.kt-menu__ver-arrow{font-size:13px!important}.submenu-heading{display:none!important}::ng-deep .kt-aside--minimize .submenu-heading{display:block!important;border-bottom:1px solid #6ca3fb80}::ng-deep .kt-aside--minimize .submenu-heading .kt-menu__link{padding-top:0!important;padding-bottom:15px!important;min-height:30px!important}::ng-deep .kt-aside--minimize .submenu-heading .kt-menu__link .kt-menu__Link-text{font-size:15px}@media (max-width: 1024px){.submenu-heading{display:none!important}}\n"]
            }]
    }], function () { return [{ type: ɵngcc1.Router }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }]; }, { showSubMenuOn: [{
            type: Input
        }], leftNav: [{
            type: ViewChild,
            args: ['leftNav', { read: ElementRef }]
        }], asideMenu: [{
            type: ViewChild,
            args: ['asideMenu', { read: ElementRef }]
        }], allSecuredObjDirectiveList: [{
            type: ViewChildren,
            args: [StgSecuredObjectDirective, { read: StgSecuredObjectDirective }]
        }], allSecuredObjDirectiveListFromTransclusion: [{
            type: ContentChildren,
            args: [StgSecuredObjectDirective, { read: StgSecuredObjectDirective }]
        }], menuList: [{
            type: Input
        }], headerLogo: [{
            type: Input
        }], staticAside: [{
            type: Input
        }], minimizeOnLoad: [{
            type: Input
        }] }); })();

// Angular
class BrandComponent {
    constructor() {
        this.toggleOptions = {
            target: 'body',
            targetState: 'kt-aside--minimize',
            togglerState: 'kt-aside__brand-aside-toggler--active'
        };
    }
    ngAfterViewInit() {
        let toggle = new KTToggle(this.brand.nativeElement, this.toggleOptions);
    }
    ngOnInit() {
    }
}
BrandComponent.ɵfac = function BrandComponent_Factory(t) { return new (t || BrandComponent)(); };
BrandComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BrandComponent, selectors: [["kt-brand"]], viewQuery: function BrandComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c5, 5, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.brand = _t.first);
    } }, inputs: { headerLogo: "headerLogo", headerText: "headerText" }, decls: 8, vars: 1, consts: [["id", "kt_aside_brand", 1, "kt-aside__brand", "kt-grid__item"], [1, "kt-aside__brand-tools"], ["id", "kt_aside_toggler", 1, "kt-aside__brand-aside-toggler", "kt-aside__brand-aside-toggler--left"], ["brand", ""], [1, "fa", "fa-bars", "fa-2x"], [1, "kt-aside__brand-logo"], ["href", "javascript:;", "routerLink", "/", 1, "left-nav-header-logo"], ["alt", "logo", "class", "left-nav-header-logo-img", 4, "ngIf"], ["alt", "logo", 1, "left-nav-header-logo-img"]], template: function BrandComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "button", 2, 3);
        ɵngcc0.ɵɵelement(4, "i", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 5);
        ɵngcc0.ɵɵelementStart(6, "a", 6);
        ɵngcc0.ɵɵtemplate(7, BrandComponent_img_7_Template, 1, 1, "img", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngIf", ctx.headerLogo);
    } }, directives: [ɵngcc1.RouterLinkWithHref, ɵngcc2.NgIf], styles: [".left-nav-header-logo[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:center}.left-nav-header-logo-img[_ngcontent-%COMP%]{max-width:195px;max-height:45px}.kt-aside__brand-aside-toggler[_ngcontent-%COMP%] > i[_ngcontent-%COMP%]{color:#d0d0d0!important}"] });
BrandComponent.ctorParameters = () => [];
BrandComponent.propDecorators = {
    headerLogo: [{ type: Input }],
    headerText: [{ type: Input }],
    brand: [{ type: ViewChild, args: ['brand', { read: ElementRef },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BrandComponent, [{
        type: Component,
        args: [{
                selector: 'kt-brand',
                template: "<!-- begin:: Brand -->\r\n<div class=\"kt-aside__brand kt-grid__item\" id=\"kt_aside_brand\">\r\n  <div class=\"kt-aside__brand-tools\">\r\n    <button #brand class=\"kt-aside__brand-aside-toggler kt-aside__brand-aside-toggler--left\" id=\"kt_aside_toggler\">\r\n      <i class=\"fa fa-bars fa-2x\"></i>\r\n    </button>\r\n  </div>\r\n\r\n  <div class=\"kt-aside__brand-logo\">\r\n    <a href=\"javascript:;\" routerLink=\"/\" class=\"left-nav-header-logo\">\r\n      <img alt=\"logo\" [attr.src]=\"headerLogo\" *ngIf=\"headerLogo\" class=\"left-nav-header-logo-img\"/>\r\n    </a>\r\n  </div>\r\n\r\n</div>\r\n<!-- end:: Brand -->\r\n",
                styles: [".left-nav-header-logo{display:flex;flex-direction:column;justify-content:center}.left-nav-header-logo-img{max-width:195px;max-height:45px}.kt-aside__brand-aside-toggler>i{color:#d0d0d0!important}\n"]
            }]
    }], function () { return []; }, { headerLogo: [{
            type: Input
        }], headerText: [{
            type: Input
        }], brand: [{
            type: ViewChild,
            args: ['brand', { read: ElementRef }]
        }] }); })();

// tslint:disable-next-line:class-name
const DEFAULT_PERFECT_SCROLLBAR_CONFIG = {
    wheelSpeed: 0.3,
    swipeEasing: true,
    minScrollbarLength: 30,
    maxScrollbarLength: 300
};
const ɵ0 = DEFAULT_PERFECT_SCROLLBAR_CONFIG;
class LeftNavModule {
}
LeftNavModule.ɵfac = function LeftNavModule_Factory(t) { return new (t || LeftNavModule)(); };
LeftNavModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: LeftNavModule });
LeftNavModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        {
            provide: PERFECT_SCROLLBAR_CONFIG,
            useValue: ɵ0
        }
    ], imports: [[
            CommonModule,
            RouterModule,
            NgbTooltipModule,
            NgbDropdownModule,
            PerfectScrollbarModule,
            OauthSessionModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LeftNavModule, [{
        type: NgModule,
        args: [{
                declarations: [LeftNavComponent, AsideLeftComponent, BrandComponent],
                imports: [
                    CommonModule,
                    RouterModule,
                    NgbTooltipModule,
                    NgbDropdownModule,
                    PerfectScrollbarModule,
                    OauthSessionModule
                ],
                providers: [
                    {
                        provide: PERFECT_SCROLLBAR_CONFIG,
                        useValue: ɵ0
                    }
                ],
                exports: [LeftNavComponent, AsideLeftComponent, BrandComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LeftNavModule, { declarations: function () { return [LeftNavComponent, AsideLeftComponent, BrandComponent]; }, imports: function () { return [CommonModule,
        RouterModule,
        NgbTooltipModule,
        NgbDropdownModule,
        PerfectScrollbarModule,
        OauthSessionModule]; }, exports: function () { return [LeftNavComponent, AsideLeftComponent, BrandComponent]; } }); })();

/*
 * Public API Surface of left-nav
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AsideLeftComponent, BrandComponent, LeftNavComponent, LeftNavModule, LeftNavService, ɵ0 };

